import type {
  RichTextContent,
  EmbedReferences,
} from '@graphcms/rich-text-types';
import type { Locale } from '@seek/melways-sites';
import gql from 'graphql-tag';

import getClient from 'src/modules/ApiClient/cms/cmsClient';

export const query = gql`
  query GetRichText($richTextSlug: String, $locale: [Locale!]!) {
    richTextEditor(where: { slug: $richTextSlug }, locales: $locale) {
      id
      content {
        raw
        references {
          ... on EmbedSingleLineText {
            id
            value
            bold
          }
        }
      }
    }
  }
`;

export interface HygraphRichTextContent {
  raw: RichTextContent;
  references: EmbedReferences;
}

type GetRichText = (
  richTextSlug: string,
  locale: Locale,
) => Promise<HygraphRichTextContent>;

const getRichText: GetRichText = async (richTextSlug, locale) => {
  const graphqlClient = getClient();

  interface Results {
    richTextEditor: { content: HygraphRichTextContent };
  }

  const formatLocale = locale.replace('-', '_');
  const result: Results = await graphqlClient.request(query, {
    richTextSlug,
    locale: [formatLocale],
  });

  return result.richTextEditor.content;
};

export default getRichText;
